import { css } from 'styled-components';

const styles = {
  container: css`
    display: flex;
    flex: 1;
    width: 100%;
    flex-direction: column;
    
    form {
      > div,
      .container,
      .section {
        border: none;
        padding: 0;
        margin: 0;
        background-color: transparent;
      }
    }
  `,
  title: css`
    display: flex;
  `,
  iconContainer: css`
    display: flex;
    justify-content: center;
    align-items: center;
  
  `,
  messageContainer:css`
    margin: 20px 0;
  `
};

export default styles;
